import IMG_GUIDE_STEP_1 from '@/assets/airport/img_guide_step_1.png';
import IMG_GUIDE_STEP_2 from '@/assets/airport/img_guide_step_2.png';

export const GUIDE_STEP = (airport: string) => [
  {
    id: 1,
    title: 'STEP 1 - Visit Customs Kiosk',
    korTitle: `STEP 1 - ${airport} 환급 키오스크 이용`,
    description: `Visit ${airport} and find the Customs Kiosk. Check the lists of goods to refund.`,
    korDescription: `인천국제공항에 방문하여 환급 키오스크를 찾아 환급 받을 
항목을 확인해주세요.`,
    image: IMG_GUIDE_STEP_1,
  },
  {
    id: 2,
    title: 'STEP 2 - Get a refund',
    korTitle: 'STEP 2 - 환급받기',
    description: 'Get refunds through the refund counter.',
    korDescription: '면세구역 환급 카운터에 방문하여 환급금을 수령하세요.',
    image: IMG_GUIDE_STEP_2,
  },
];

export const FAQ_LIST = [
  {
    title: 'How is the tax refund process going?',
    content: (
      <>
        <strong>
          Visit customs kiosk → Check refund list → Visit Refund Counter
        </strong>
        <br />
        If customs requests your receipt, please tap the receipt on the home
        screen and show it to them.
      </>
    ),
  },
  {
    title: 'What should I do if I couldn’t receive my refund at the airport?',
    content: (
      <>
        <strong>Please leave a message through the Contact.</strong>
      </>
    ),
  },
];

export const FAQ_LIST_KOR = [
  {
    title: '환급절차가 어떻게 되나요?',
    content: (
      <>
        <strong>환급 키오스크 방문 → 환급 목록 확인 → 환급 창구 방문</strong>
        <br />
        세관에서 공급내역서 요청시 홈 화면에 있는 영수증을 클릭하여 보여주세요.
      </>
    ),
  },
  {
    title: '환급금을 공항에서 수령하지 못했을 때 어떻게 하나요?',
    content: (
      <>
        <strong>문의하기를 통해 메시지를 남겨주세요.</strong>
      </>
    ),
  },
];
